module.exports = __webpack_public_path__ + "img/advantage2.2893d2b6.png";